import React from 'react';
import {sendButtonClickEvent} from '../../../analytics/gameAnalytics';
import {MENU_SOUND_MANAGER} from "../../../scenes/MenuSoundManager";

// isGuest разбирается отдельно от ...rest намеренно: в DOM этот проп попасть
// не должен, он нужен только событию клика (см. sendButtonClickEvent)
const PageButton = ({onClick, noSound, children, pageId, buttonId, buttonValue, isGuest, className, ...rest}) => {
  const handleClick = (e) => {
    if (pageId && buttonId) {
      sendButtonClickEvent(pageId, buttonId, buttonValue, {isGuest});
    }
    if (!noSound) {
      MENU_SOUND_MANAGER.playMenuButtonClick();
    }
    if (onClick) {
      onClick(e);
    }
  };

  return (
    <button className={`main-menu-button ${className ? className : ''}`} {...rest} onClick={handleClick}>
      {children}
    </button>
  );
};

export default PageButton;
